import { i18n } from '@fs/zion-locale'

export default {
  id: () => i18n.t('cameraOperatorsOverlayId', 'ID'),
}
